// Load Highcharts
var Highcharts = require('highcharts');
// This is how a module is loaded. Pass in Highcharts as a parameter.
require('highcharts/modules/exporting')(Highcharts);

var publications_chart_data = $('#publications_chart');
var citations_chart_data = $('#citations_chart');


// Generate publications chart
var publications_chart = Highcharts.chart('publications_chart', {

    title: {
        text: publications_chart_data.data('title')
    },

    xAxis: {
        categories: publications_chart_data.data('xaxis'),

        title: {
            text: publications_chart_data.data('x_axis_title'),
        },
        labels: {
          rotation: 90,
          step: 1
        }
    },

    yAxis: {
        title: {
            text: publications_chart_data.data('yaxis_title'),
        }
    },

    labels: {
        items: [{
            style: {
                left: '50px',
                top: '18px',
            }
        }]
    },

    series: [{
        type: 'column',
        name: 'Cumulative',
        data: publications_chart_data.data('cumulative'),
        color: publications_chart_data.data('color'),
      },
      {
          type: 'spline',
          name: 'Per year',
          data: publications_chart_data.data('yaxis'),
          marker: {
              lineWidth: 2,
              lineColor: '#434348',
              fillColor: 'white'
          },
          lineWidth: 3,
          color: '#434348',
      },
    ],
    credits: false,
});

// Generate citations chart
var citations_chart = Highcharts.chart('citations_chart', {

    title: {
        text: citations_chart_data.data('title')
    },

    xAxis: {
        categories: citations_chart_data.data('xaxis'),

        title: {
            text: citations_chart_data.data('x_axis_title'),
        },
        labels: {
          rotation: 90,
          step: 1
        }
    },

    yAxis: {
        title: {
            text: citations_chart_data.data('yaxis_title'),
        }
    },

    labels: {
        items: [{
            style: {
                left: '50px',
                top: '18px',
            }
        }]
    },

    series: [{
        type: 'column',
        name: 'Cumulative',
        data: citations_chart_data.data('cumulative'),
        color: citations_chart_data.data('color'),
      },
      {
          type: 'spline',
          name: 'Per year',
          data: citations_chart_data.data('yaxis'),
          marker: {
              lineWidth: 2,
              lineColor: '#434348',
              fillColor: 'white'
          },
          lineWidth: 3,
          color: '#434348',
      },
    ],
    credits: false,
});
